var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReportOutlined = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_258)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4C5.77614 4 6 4.22386 6 4.5V7.5C6 7.77614 6.22386 8 6.5 8H17.5C17.7761 8 18 7.77614 18 7.5V4.5C18 4.22386 18.2239 4 18.5 4H20.007C20.555 4 21 4.445 21 4.993V21.007C20.9997 21.2703 20.895 21.5227 20.7089 21.7089C20.5227 21.895 20.2703 21.9997 20.007 22H3.993C3.72972 21.9997 3.4773 21.895 3.29114 21.7089C3.10497 21.5227 3.00026 21.2703 3 21.007V4.993C3 4.445 3.445 4 3.993 4H5.5ZM8 2.5C8 2.22386 8.22386 2 8.5 2H15.5C15.7761 2 16 2.22386 16 2.5V5.5C16 5.77614 15.7761 6 15.5 6H8.5C8.22386 6 8 5.77614 8 5.5V2.5ZM7 14.5C7 14.2239 7.22386 14 7.5 14H12.5C12.7761 14 13 14.2239 13 14.5V15.5C13 15.7761 12.7761 16 12.5 16H7.5C7.22386 16 7 15.7761 7 15.5V14.5ZM17 10.5C17 10.2239 16.7761 10 16.5 10H7.5C7.22386 10 7 10.2239 7 10.5V11.5C7 11.7761 7.22386 12 7.5 12H16.5C16.7761 12 17 11.7761 17 11.5V10.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 10,
    height: 2,
    rx: 0.5,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 6,
    height: 2,
    rx: 0.5,
    fill: "transparent"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReportOutlined, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ReportOutlined.d745e17e.svg";
export { ForwardRef as ReactComponent };